// NEW_FILE_JUSTIFIED: Extracted KB wrapper components from PageWrappers.tsx to keep it under 300-line limit
import { AppLayoutMemo } from '@/components/layout';
import { KnowledgeBasePageWithOrgGuard } from '@/pages/insurance/KnowledgeBasePage';

export function InsuranceKnowledgeBasePageWrapper() {
  return (
    <AppLayoutMemo>
      <KnowledgeBasePageWithOrgGuard />
    </AppLayoutMemo>
  );
}

export function RealEstateKnowledgeBasePageWrapper() {
  return (
    <AppLayoutMemo>
      <KnowledgeBasePageWithOrgGuard />
    </AppLayoutMemo>
  );
}
